<app-login></app-login>
<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav" #stickyMenu [class.navbar-shrink]="sticky">
  <div class="container">
    <a class="navbar-brand js-scroll-trigger" routerLink="/" aria-label="Voltar à página inicial"
      ><span class="icon"></span
    ></a>
    <div class="navbar-title" [class.navbar-inicial]="paginaInicial">BolCó 2026</div>
    <div class="navbar-buttons">
      @if (isLoggedIn) {
        <button mat-button class="top-button" routerLink="/jogos" aria-label="Jogos da Copa">Jogos</button>
      }
      @if (isLoggedIn) {
        <button mat-button class="top-button" routerLink="/grupos" aria-label="Grupos de Amigos">Grupos</button>
      }
      @if (!isLoggedIn) {
        <button mat-button class="top-button" (click)="login()" aria-label="Entra na área privada">Login</button>
      }
      @if (!isLoggedIn) {
        <button mat-button class="top-button" (click)="register()" aria-label="Cadastro para o site">Cadastrar</button>
      }
    </div>
    @if (isLoggedIn) {
      <button
        mat-button
        class="navbar-toggler-inv"
        type="button"
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="ap1RespMain"
        aria-label="Auditoria dos palpites">
        <mat-icon>person</mat-icon> &nbsp;
        <span>{{ username }}</span>
      </button>
    }
    @if (isLoggedIn) {
      <button
        mat-button
        class="navbar-toggler navbar-resp-menu"
        type="button"
        [matMenuTriggerFor]="ap1RespMain"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Menu de navegação">
        <mat-icon class="nav-menu-icon">menu</mat-icon>
      </button>
    }
  </div>
  @if (!online) {
    <div class="no-connection">Sem conexão</div>
  }
</nav>

<mat-menu #ap1RespMain="matMenu" xPosition="before">
  <div (mouseleave)="closeUserMenu(ap1RespMain)" class="but-menu-container">
    @if (!(authService.user | async)) {
      <button mat-menu-item class="only_responsive" (click)="login()">
        <mat-icon class="but-icon-menu">login</mat-icon>
        <span>Entrar</span>
      </button>
    }
    @if (!isLoggedIn) {
      <button mat-menu-item class="only_responsive" (click)="register()">
        <mat-icon class="but-icon-menu">how_to_reg</mat-icon>
        <span>Cadastrar</span>
      </button>
    }
    @if (isLoggedIn) {
      <button mat-menu-item class="but-menu" routerLink="/perfil" aria-label="Exibe as prefrências do perfil">
        <mat-icon class="but-icon-menu">face</mat-icon>
        <span>Preferências</span>
      </button>
    }
    @if (isLoggedIn) {
      <button mat-menu-item class="but-menu" routerLink="/audit" aria-label="Preferências do usuário">
        <mat-icon class="but-icon-menu">receipt_long</mat-icon>
        <span>Auditoria</span>
      </button>
    }
    @if (authService.isAdmin | async) {
      <button mat-menu-item class="but-menu" routerLink="/adm" aria-label="Área de administração">
        <mat-icon class="but-icon-menu">donut_small</mat-icon>
        <span>Admin</span>
      </button>
    }
    @if (isLoggedIn) {
      <button mat-menu-item class="but-menu" (click)="logout()" aria-label="Sai da área privada">
        <mat-icon class="but-icon-menu">exit_to_app</mat-icon>
        <span>Sair</span>
      </button>
    }
  </div>
</mat-menu>
